var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenseaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D8A016;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "opensea"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st0",
    d: "M45.2,90C20.2,90,0,69.8,0,45S20.2,0,45.2,0c3,0,6.1,0.4,9.1,0.9c1.7,0.4,3.2,0.8,4.9,1.3 c0.8,0.2,1.3,1.1,0.9,1.9C59.9,4.9,59,5.4,58.2,5c-1.5-0.6-3-0.9-4.5-1.1C50.9,3.4,48,3,45.2,3C21.9,3,3,21.9,3,45 s18.9,42,42,42s42-18.8,42-42c0-6.9-1.7-13.7-4.9-19.7c-0.4-0.7-0.2-1.7,0.6-2.1c0.8-0.4,1.7-0.2,2.1,0.6 C88.1,30.4,90,37.7,90,45C90.2,69.8,70,90,45.2,90"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st0",
    d: "M76.6,15.8c-0.4,0-0.8-0.2-0.9-0.6c-0.9-1.1-2.1-2.2-3.2-3.4c-0.9-0.8-1.7-1.5-2.6-2.2 C69,9,69,8.1,69.4,7.3s1.3-0.9,2.1-0.4c0.9,0.8,1.9,1.5,2.8,2.4c1.1,1.1,2.5,2.3,3.4,3.6c0.6,0.6,0.6,1.7,0,2.4 C77.3,15.6,77,15.8,76.6,15.8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M74.5,48.2v3c0,0.1-0.1,0.3-0.2,0.4c-0.9,0.4-4.2,1.9-5.3,3.6c-3.4,4.7-5.9,11.2-11.5,11.2h-24 c-8.3,0-15.3-6.9-15.3-15.4v-0.2c0-0.2,0.2-0.4,0.4-0.4H32c0.2,0,0.4,0.2,0.4,0.4c0,0.8,0,1.7,0.4,2.6c0.8,1.7,2.5,2.6,4.2,2.6 h6.6v-5h-6.4c-0.4,0-0.6-0.4-0.4-0.6c0,0,0.2-0.2,0.2-0.4c0.6-0.9,1.5-2.2,2.5-3.8c0.6-0.9,1.1-2.2,1.7-3.4 c0-0.2,0.2-0.4,0.2-0.6c0-0.4,0.2-0.8,0.4-0.9c0.2-0.2,0.2-0.6,0.2-0.8c0.2-0.9,0.2-1.9,0.2-3v-2.6c0-0.4,0-0.7-0.2-1.1 c0-0.6-0.2-1.1-0.4-1.9v-0.2c0-0.4-0.2-0.8-0.4-1.1c-0.4-1.3-0.8-2.6-1.3-3.6c-0.2-0.4-0.4-0.9-0.6-1.3 c-0.2-0.6-0.6-1.3-0.8-1.9c0-0.2-0.2-0.4-0.4-0.7c0-0.2-0.2-0.6-0.4-0.8l-0.2-0.6l-0.8-1.5c0-0.2,0-0.4,0.2-0.4l5.1,1.3l0.6,0.2 l0.8,0.2h0.2v-3c0-1.5,1.1-2.6,2.6-2.6c0.8,0,1.3,0.2,1.9,0.8c0.4,0.4,0.8,1.1,0.8,1.9v4.3l0.6,0.2l0,0c0,0,0.2,0.2,0.6,0.4 c0.2,0.2,0.4,0.4,0.6,0.6c0.4,0.4,1.1,0.9,1.7,1.5c0.2,0.2,0.4,0.2,0.4,0.4c0.8,0.7,1.7,1.7,2.6,2.6c0.2,0.2,0.4,0.6,0.8,0.8 c0.2,0.2,0.4,0.6,0.8,0.9c0.2,0.4,0.6,0.7,0.9,1.1c0,0.2,0.2,0.4,0.4,0.6c0.4,0.6,0.6,1.1,0.9,1.7c0,0.2,0.2,0.6,0.4,0.8 c0.4,0.8,0.6,1.5,0.8,2.2v3.5c0,0.4-0.2,0.6-0.2,0.9c0,0.2-0.2,0.6-0.4,0.9c-0.2,0.6-0.6,1.3-0.9,1.9c0,0.2-0.2,0.4-0.4,0.8 c-0.2,0.2-0.4,0.4-0.4,0.8c-0.2,0.2-0.4,0.6-0.6,0.7c-0.2,0.2-0.4,0.6-0.6,0.8c-0.2,0.4-0.6,0.8-0.9,1.1l-0.6,0.6l-0.6,0.6 L54,50.1l-0.6,0.4h-4.2v5.1h5.1c1.1,0,2.3-0.4,3-1.1c0.2-0.2,1.5-1.3,3-3h0.2l13.8-3.9C74.3,47.6,74.5,47.8,74.5,48.2"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenseaLogo);
export default __webpack_public_path__ + "static/media/opensea-logo.0be83ef293a0d563b87924002b3df813.svg";
export { ForwardRef as ReactComponent };